export default {
    cn: {
        analyze: {
            dateText: '日期：',
            statusText: '状态：',
            status: { '-1': '所有', '0': '删除', '1': '禁用', '2': '启用', '3': '新建', '4': '未知' },
            excelName: '账户分析报表',
            desc: {
                '0': '账号在 start 有日结数据，在 end 无日结数据，并且当前在MT5无账号记录',
                '1': '账号在 start 有日结数据，在 end 无日结数据，并且当前在MT5有账号记录',
                '2': '账号在 start 无日结数据，在 end 有日结数据，并且账号的注册日期早于 start',
                '3': '账号在 start 无日结数据，在 end 有日结数据，并且账号的注册日期晚于 start',
                '4': '账号在 start 无日结数据，在 end 有日结数据，并且当前在MT5无账号记录'
            },
            description: '状态描述',
            badWeekday: '请不要选择周六，周六无日结数据.',
            tableHead: [
                { key: 'LOGIN', value: '账号' },
                { key: 'GROUP', value: '组别' },
                { key: 'CURRENCY', value: '入金货币' },
                { key: 'BALANCE', value: '余额' },
                { key: 'status', value: '状态' },
            ]
        }
    },
    hk: {
        analyze: {
            dateText: '日期：',
            statusText: '狀態：',
            status: { '-1': '所有', '0': '刪除', '1': '禁用', '2': '啟用', '3': '新建', '4': '未知' },
            excelName: '賬戶分析報表',
            desc: {
                '0': '賬號在 start 有日結數據，在 end 無日結數據，并且當前在MT5無賬號記錄',
                '1': '賬號在 start 有日結數據，在 end 無日結數據，并且當前在MT5有賬號記錄',
                '2': '賬號在 start 無日結數據，在 end 有日結數據，并且賬號的注冊日期早於 start',
                '3': '賬號在 start 無日結數據，在 end 有日結數據，并且賬號的注冊日期晚於 start',
                '4': '賬號在 start 無日結數據，在 end 有日結數據，并且當前在MT5無賬號記錄'
            },
            description: '狀態描述',
            badWeekday: '請不要選擇週六，週六無日結數據.',
            tableHead: [
                { key: 'LOGIN', value: '賬號' },
                { key: 'GROUP', value: '組別' },
                { key: 'CURRENCY', value: '入金貨幣' },
                { key: 'BALANCE', value: '餘額' },
                { key: 'status', value: '狀態' },
            ]
        }
    },
    en: {
        analyze: {
            dateText: 'Date：',
            statusText: 'Status：',
            status: { '-1': 'All', '0': 'Delete', '1': 'Disable', '2': 'Enable', '3': 'Create', '4': 'Unknow' },
            excelName: 'Account Analyze Report',
            desc: {
                '0': 'The account has daily record on start and no record on end，and can\'t find account record in MT5 now',
                '1': 'The account has daily record on start and no record on end, and can find account record in MT5 now',
                '2': 'The account has daily record on end and no record on start, and the account is registered earlier than start',
                '3': 'The account has daily record on end and no record on start, and the account is registered later than start',
                '4': 'The account has daily record on end and no record on start, and can\'t find account record in MT5 now'
            },
            description: 'Status description',
            badWeekday: 'Please do not select saturday, saturday has no data.',
            tableHead: [
                { key: 'LOGIN', value: 'Login' },
                { key: 'GROUP', value: 'Group' },
                { key: 'CURRENCY', value: 'Currency' },
                { key: 'BALANCE', value: 'Balance' },
                { key: 'status', value: 'Status' },
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/manager-report/analyze.js